import { useEffect, FC, useMemo } from 'react';

import { t } from 'i18next';
import _ from 'lodash';

import ClassDropDown from 'components/Header/components/ClassDropDown/ClassDropDown';
import { getSubjectsThunk, studySubjectsState } from 'redux/study/studySubjects.slice';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { getUser } from 'redux/authentication/auth.slice';

interface iSelectSubject {
  handleSelect: any;
  parentId: string;
  selectedId: string;
}

const SelectSubject: FC<iSelectSubject> = ({ handleSelect, parentId, selectedId }) => {
  const subjects = useAppSelector(studySubjectsState);
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUser);

  function printSubjects() {
    return subjects.subjects
      .filter(obj => {
        return obj.teaching_structure.parent.id === parentId;
      })
      .map(obj => {
        return (
          <div
            key={obj.id}
            className="pointer text text-normal"
            onClick={() =>
              handleSelect({
                title: obj.teaching_structure.title,
                id: obj.teaching_structure_id,
              })
            }
          >
            {obj.teaching_structure.title}
          </div>
        );
      });
  }

  useEffect(() => {
    handleSelect({
      title: '',
      id: '',
    });
  }, [parentId]);

  const selected = useMemo(() => {
    if (!selectedId) {
      return {
        title: t('common:SelectSubject'),
        id: '',
      };
    }
    const selectedObj = _.find(subjects.subjects, obj => obj.teaching_structure_id === selectedId);

    if (!selectedObj) {
      return {
        title: t('common:SelectSubject'),
        id: '',
      };
    }
    return selectedObj.teaching_structure;
  }, [selectedId]);

  useEffect(() => {
    dispatch(getSubjectsThunk(user.id));
  }, []);

  return (
    <>
      <label htmlFor="subject">{t('common:SelectSubject')}</label>
      <ClassDropDown
        style={{ width: '100%' }}
        styleDropDown={{ width: '100%' }}
        key={selected.id}
        value={selected.title}
      >
        {printSubjects()}
      </ClassDropDown>
    </>
  );
};

export default SelectSubject;
